import requiredFields from './functions/requiredFields';
import onInputChange from './functions/onInputChange';

export default {
    requiredFields,
    onInputChange
}
